import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  LogActivityMutation,
  LogActivityMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const logActivityDocument = graphql(`
  mutation logActivity($input: LogActivityRequest!) {
    logActivity(input: $input)
  }
`);

/** Records a view or search by the current user, for usage reports and "seen by". */
export function useLogActivity(
  options?: UseMutationOptions<LogActivityMutation, unknown, LogActivityMutationVariables, unknown>,
) {
  return useGraphQlMutation(logActivityDocument, options);
}
